"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("connected-react-router/immutable");

var _reactRouterDom = require("react-router-dom");

var _Loader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Loader"));

var _BaseLayout = _interopRequireDefault(require("cornerstone_ui_core/lib/containers/BaseLayout"));

var _DynamicRoutes = _interopRequireDefault(require("cornerstone_ui_core/lib/components/DynamicRoutes"));

var _CallbackHandler = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CallbackHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AppRouter = function AppRouter(_ref) {
  var defaultRoute = _ref.defaultRoute,
      routes = _ref.routes,
      history = _ref.history;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_immutable.ConnectedRouter, {
    history: history
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/callback"
  }, /*#__PURE__*/_react.default.createElement(_CallbackHandler.default, {
    defaultRoute: defaultRoute
  })), /*#__PURE__*/_react.default.createElement(_BaseLayout.default, {
    routes: routes
  }, function (user) {
    return /*#__PURE__*/_react.default.createElement(_DynamicRoutes.default, {
      match: {
        url: ""
      },
      routes: routes
    });
  })))));
};

var _default = AppRouter;
exports.default = _default;